import type { ContentObjectList, ContentObjectView, NonEventContentObjectDetail } from 'models';
import type { ReactNode } from 'react';
import { useUser } from 'features/auth';
import { BasicActionBar } from './basic-action-bar';
import { GroupActionBar } from './group-action-bar';
import { ProgramActionBar } from './program-action-bar';

type P = {
  item: ContentObjectList | NonEventContentObjectDetail;
  onShowComments?: () => void;
  preview: ReactNode;
  view: ContentObjectView;
};

const ActionBar = ({ item, onShowComments, preview, view }: P) => {
  const user = useUser({ requiredAuth: false });

  if (!user) {
    return null;
  }

  switch (item.contentableType) {
    case 'Community':
    case 'Organization':
      return <BasicActionBar item={item} onShowComments={onShowComments} preview={preview} view={view} />;
    case 'Group':
      return <GroupActionBar item={item} />;
    case 'Program':
      return <ProgramActionBar item={item} onShowComments={onShowComments} view={view} />;
    case undefined:
      if ('event' in item) {
        return <BasicActionBar item={item} onShowComments={onShowComments} preview={preview} view={view} />;
      }

      return null;
    default:
      return null;
  }
};

export default ActionBar;
